import useFormatMessage from 'hooks/useFormatMessage';
import c from '@ftrprf/tailwind-components/src/utils/c';
import { linkFocusStyles, linkHoverStyles } from '@ftrprf/tailwind-components';

export function DemoSuperlightInfoBar() {
  const t = useFormatMessage();

  return (
    <div className="flex w-full bg-accent-50 text-accent-800 border-b border-gray-300 p-8 justify-center">
      <p>
        {t('demo.superlight.infobar')}{' '}
        <a
          className={c(
            linkFocusStyles,
            linkHoverStyles,
            'hover:text-accent-900 hover:decoration-dashed underline',
          )}
          href="https://demo.ftrprf.be/#request-form"
          rel="noopener noreferrer"
          target="_blank"
        >
          demo.ftrprf.be
        </a>
        .
      </p>
    </div>
  );
}
